module.exports = __webpack_public_path__ + "img/Le_Parisien_logo.c32a5a98.svg";